export default {
  view: 2,
  sidebar_active: false,
  show_title: true
}